/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { OrderDirection } from '../models/order-direction';
import { ProductionResourceDto } from '../models/production-resource-dto';
import { ProductionResourceDtoBaseResponse } from '../models/production-resource-dto-base-response';
import { ProductionResourceDtoListBaseResponse } from '../models/production-resource-dto-list-base-response';
import { PropertyFilter } from '../models/property-filter';
import { StringBaseResponse } from '../models/string-base-response';
import { WorkOrderCommentDto } from '../models/work-order-comment-dto';
import { WorkOrderCommentDtoBaseResponse } from '../models/work-order-comment-dto-base-response';
import { WorkOrderDto } from '../models/work-order-dto';
import { WorkOrderDtoBaseResponse } from '../models/work-order-dto-base-response';
import { WorkOrderListDto } from '../models/work-order-list-dto';
import { WorkOrderListDtoBaseResponse } from '../models/work-order-list-dto-base-response';
import { WorkOrderListDtoListBaseResponse } from '../models/work-order-list-dto-list-base-response';
import { WorkOrderListDtoPagedResponseBaseResponse } from '../models/work-order-list-dto-paged-response-base-response';
import { WorkOrderStageInfoDto } from '../models/work-order-stage-info-dto';
import { WorkOrderStageInfoDtoBaseResponse } from '../models/work-order-stage-info-dto-base-response';
import { WorkOrderStatus } from '../models/work-order-status';
import { WorkOrderSwimlane } from '../models/work-order-swimlane';
import { WorkOrderSwimlaneDefinitionDto } from '../models/work-order-swimlane-definition-dto';
import { WorkOrderSwimlaneDefinitionDtoBaseResponse } from '../models/work-order-swimlane-definition-dto-base-response';
import { WorkOrderSwimlaneDefinitionDtoListBaseResponse } from '../models/work-order-swimlane-definition-dto-list-base-response';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiWorkOrderGetAllGet
   */
  static readonly ApiWorkOrderGetAllGetPath = '/api/WorkOrder/get-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetAllGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<WorkOrderListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetAllGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetAllGet$Plain(params?: {
  }): Observable<WorkOrderListDtoListBaseResponse> {

    return this.apiWorkOrderGetAllGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderListDtoListBaseResponse>) => r.body as WorkOrderListDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetAllGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<WorkOrderListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetAllGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetAllGet$Json(params?: {
  }): Observable<WorkOrderListDtoListBaseResponse> {

    return this.apiWorkOrderGetAllGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderListDtoListBaseResponse>) => r.body as WorkOrderListDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderPaginatedListGet
   */
  static readonly ApiWorkOrderPaginatedListGetPath = '/api/WorkOrder/paginated-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderPaginatedListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderPaginatedListGet$Plain$Response(params?: {

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    Status?: WorkOrderStatus;
    MachineId?: number;

    /**
     * 0 &#x3D; Backlog
     * 
     * 1 &#x3D; ThirdParty
     * 
     * 2 &#x3D; AwaitingCollection
     * 
     * 3 &#x3D; GoodsIn
     * 
     * 4 &#x3D; QaInspection
     * 
     * 5 &#x3D; Gauging
     * 
     * 6 &#x3D; ProofLoad
     * 
     * 7 &#x3D; FirstStageBuild
     * 
     * 8 &#x3D; Calibration
     * 
     * 9 &#x3D; FinalBuild
     * 
     * 10 &#x3D; PressureTest
     * 
     * 11 &#x3D; FinalInspection
     * 
     * 12 &#x3D; ReadyForDispatch
     * 
     * 13 &#x3D; Dispatched
     */
    Swimlane?: WorkOrderSwimlane;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<WorkOrderListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderPaginatedListGetPath, 'get');
    if (params) {
      rb.query('Status', params.Status, {});
      rb.query('MachineId', params.MachineId, {});
      rb.query('Swimlane', params.Swimlane, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderPaginatedListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderPaginatedListGet$Plain(params?: {

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    Status?: WorkOrderStatus;
    MachineId?: number;

    /**
     * 0 &#x3D; Backlog
     * 
     * 1 &#x3D; ThirdParty
     * 
     * 2 &#x3D; AwaitingCollection
     * 
     * 3 &#x3D; GoodsIn
     * 
     * 4 &#x3D; QaInspection
     * 
     * 5 &#x3D; Gauging
     * 
     * 6 &#x3D; ProofLoad
     * 
     * 7 &#x3D; FirstStageBuild
     * 
     * 8 &#x3D; Calibration
     * 
     * 9 &#x3D; FinalBuild
     * 
     * 10 &#x3D; PressureTest
     * 
     * 11 &#x3D; FinalInspection
     * 
     * 12 &#x3D; ReadyForDispatch
     * 
     * 13 &#x3D; Dispatched
     */
    Swimlane?: WorkOrderSwimlane;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<WorkOrderListDtoPagedResponseBaseResponse> {

    return this.apiWorkOrderPaginatedListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderListDtoPagedResponseBaseResponse>) => r.body as WorkOrderListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderPaginatedListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderPaginatedListGet$Json$Response(params?: {

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    Status?: WorkOrderStatus;
    MachineId?: number;

    /**
     * 0 &#x3D; Backlog
     * 
     * 1 &#x3D; ThirdParty
     * 
     * 2 &#x3D; AwaitingCollection
     * 
     * 3 &#x3D; GoodsIn
     * 
     * 4 &#x3D; QaInspection
     * 
     * 5 &#x3D; Gauging
     * 
     * 6 &#x3D; ProofLoad
     * 
     * 7 &#x3D; FirstStageBuild
     * 
     * 8 &#x3D; Calibration
     * 
     * 9 &#x3D; FinalBuild
     * 
     * 10 &#x3D; PressureTest
     * 
     * 11 &#x3D; FinalInspection
     * 
     * 12 &#x3D; ReadyForDispatch
     * 
     * 13 &#x3D; Dispatched
     */
    Swimlane?: WorkOrderSwimlane;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<WorkOrderListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderPaginatedListGetPath, 'get');
    if (params) {
      rb.query('Status', params.Status, {});
      rb.query('MachineId', params.MachineId, {});
      rb.query('Swimlane', params.Swimlane, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderPaginatedListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderPaginatedListGet$Json(params?: {

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    Status?: WorkOrderStatus;
    MachineId?: number;

    /**
     * 0 &#x3D; Backlog
     * 
     * 1 &#x3D; ThirdParty
     * 
     * 2 &#x3D; AwaitingCollection
     * 
     * 3 &#x3D; GoodsIn
     * 
     * 4 &#x3D; QaInspection
     * 
     * 5 &#x3D; Gauging
     * 
     * 6 &#x3D; ProofLoad
     * 
     * 7 &#x3D; FirstStageBuild
     * 
     * 8 &#x3D; Calibration
     * 
     * 9 &#x3D; FinalBuild
     * 
     * 10 &#x3D; PressureTest
     * 
     * 11 &#x3D; FinalInspection
     * 
     * 12 &#x3D; ReadyForDispatch
     * 
     * 13 &#x3D; Dispatched
     */
    Swimlane?: WorkOrderSwimlane;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<WorkOrderListDtoPagedResponseBaseResponse> {

    return this.apiWorkOrderPaginatedListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderListDtoPagedResponseBaseResponse>) => r.body as WorkOrderListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderGetWorkOrderPost
   */
  static readonly ApiWorkOrderGetWorkOrderPostPath = '/api/WorkOrder/get-work-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetWorkOrderPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetWorkOrderPost$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<WorkOrderDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetWorkOrderPostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetWorkOrderPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetWorkOrderPost$Plain(params?: {
    id?: number;
  }): Observable<WorkOrderDtoBaseResponse> {

    return this.apiWorkOrderGetWorkOrderPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderDtoBaseResponse>) => r.body as WorkOrderDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetWorkOrderPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetWorkOrderPost$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<WorkOrderDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetWorkOrderPostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetWorkOrderPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetWorkOrderPost$Json(params?: {
    id?: number;
  }): Observable<WorkOrderDtoBaseResponse> {

    return this.apiWorkOrderGetWorkOrderPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderDtoBaseResponse>) => r.body as WorkOrderDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderAddWorkOrderPost
   */
  static readonly ApiWorkOrderAddWorkOrderPostPath = '/api/WorkOrder/add-work-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddWorkOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddWorkOrderPost$Plain$Response(params?: {
    body?: WorkOrderListDto
  }): Observable<StrictHttpResponse<WorkOrderListDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddWorkOrderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderListDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddWorkOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddWorkOrderPost$Plain(params?: {
    body?: WorkOrderListDto
  }): Observable<WorkOrderListDtoBaseResponse> {

    return this.apiWorkOrderAddWorkOrderPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderListDtoBaseResponse>) => r.body as WorkOrderListDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddWorkOrderPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddWorkOrderPost$Json$Response(params?: {
    body?: WorkOrderListDto
  }): Observable<StrictHttpResponse<WorkOrderListDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddWorkOrderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderListDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddWorkOrderPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddWorkOrderPost$Json(params?: {
    body?: WorkOrderListDto
  }): Observable<WorkOrderListDtoBaseResponse> {

    return this.apiWorkOrderAddWorkOrderPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderListDtoBaseResponse>) => r.body as WorkOrderListDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderUpdateWorkOrderPost
   */
  static readonly ApiWorkOrderUpdateWorkOrderPostPath = '/api/WorkOrder/update-work-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateWorkOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateWorkOrderPost$Plain$Response(params?: {
    userName?: string;
    body?: WorkOrderDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateWorkOrderPostPath, 'post');
    if (params) {
      rb.query('userName', params.userName, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateWorkOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateWorkOrderPost$Plain(params?: {
    userName?: string;
    body?: WorkOrderDto
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateWorkOrderPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateWorkOrderPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateWorkOrderPost$Json$Response(params?: {
    userName?: string;
    body?: WorkOrderDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateWorkOrderPostPath, 'post');
    if (params) {
      rb.query('userName', params.userName, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateWorkOrderPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateWorkOrderPost$Json(params?: {
    userName?: string;
    body?: WorkOrderDto
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateWorkOrderPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderUpdateWorkOrderStatusPut
   */
  static readonly ApiWorkOrderUpdateWorkOrderStatusPutPath = '/api/WorkOrder/update-work-order-status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateWorkOrderStatusPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderUpdateWorkOrderStatusPut$Plain$Response(params?: {
    workOrderId?: number;

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    status?: WorkOrderStatus;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateWorkOrderStatusPutPath, 'put');
    if (params) {
      rb.query('workOrderId', params.workOrderId, {});
      rb.query('status', params.status, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateWorkOrderStatusPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderUpdateWorkOrderStatusPut$Plain(params?: {
    workOrderId?: number;

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    status?: WorkOrderStatus;
    userName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateWorkOrderStatusPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateWorkOrderStatusPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderUpdateWorkOrderStatusPut$Json$Response(params?: {
    workOrderId?: number;

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    status?: WorkOrderStatus;
    userName?: string;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateWorkOrderStatusPutPath, 'put');
    if (params) {
      rb.query('workOrderId', params.workOrderId, {});
      rb.query('status', params.status, {});
      rb.query('userName', params.userName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateWorkOrderStatusPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderUpdateWorkOrderStatusPut$Json(params?: {
    workOrderId?: number;

    /**
     * 0 &#x3D; Created
     * 
     * 1 &#x3D; Released
     * 
     * 2 &#x3D; InProgress
     * 
     * 3 &#x3D; QaHold
     * 
     * 4 &#x3D; Cancelled
     * 
     * 5 &#x3D; Complete
     */
    status?: WorkOrderStatus;
    userName?: string;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateWorkOrderStatusPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderUpdateCardPositionsPut
   */
  static readonly ApiWorkOrderUpdateCardPositionsPutPath = '/api/WorkOrder/update-card-positions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateCardPositionsPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateCardPositionsPut$Plain$Response(params?: {
    userName?: string;
    body?: Array<WorkOrderListDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateCardPositionsPutPath, 'put');
    if (params) {
      rb.query('userName', params.userName, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateCardPositionsPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateCardPositionsPut$Plain(params?: {
    userName?: string;
    body?: Array<WorkOrderListDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateCardPositionsPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateCardPositionsPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateCardPositionsPut$Json$Response(params?: {
    userName?: string;
    body?: Array<WorkOrderListDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateCardPositionsPutPath, 'put');
    if (params) {
      rb.query('userName', params.userName, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateCardPositionsPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateCardPositionsPut$Json(params?: {
    userName?: string;
    body?: Array<WorkOrderListDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateCardPositionsPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderAddCommentPost
   */
  static readonly ApiWorkOrderAddCommentPostPath = '/api/WorkOrder/add-comment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddCommentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddCommentPost$Plain$Response(params?: {
    body?: WorkOrderCommentDto
  }): Observable<StrictHttpResponse<WorkOrderCommentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddCommentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderCommentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddCommentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddCommentPost$Plain(params?: {
    body?: WorkOrderCommentDto
  }): Observable<WorkOrderCommentDtoBaseResponse> {

    return this.apiWorkOrderAddCommentPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderCommentDtoBaseResponse>) => r.body as WorkOrderCommentDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddCommentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddCommentPost$Json$Response(params?: {
    body?: WorkOrderCommentDto
  }): Observable<StrictHttpResponse<WorkOrderCommentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddCommentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderCommentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddCommentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddCommentPost$Json(params?: {
    body?: WorkOrderCommentDto
  }): Observable<WorkOrderCommentDtoBaseResponse> {

    return this.apiWorkOrderAddCommentPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderCommentDtoBaseResponse>) => r.body as WorkOrderCommentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderAreAllSiblingsCompleteGet
   */
  static readonly ApiWorkOrderAreAllSiblingsCompleteGetPath = '/api/WorkOrder/are-all-siblings-complete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAreAllSiblingsCompleteGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderAreAllSiblingsCompleteGet$Plain$Response(params?: {
    workOrderId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAreAllSiblingsCompleteGetPath, 'get');
    if (params) {
      rb.query('workOrderId', params.workOrderId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAreAllSiblingsCompleteGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderAreAllSiblingsCompleteGet$Plain(params?: {
    workOrderId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderAreAllSiblingsCompleteGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAreAllSiblingsCompleteGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderAreAllSiblingsCompleteGet$Json$Response(params?: {
    workOrderId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAreAllSiblingsCompleteGetPath, 'get');
    if (params) {
      rb.query('workOrderId', params.workOrderId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAreAllSiblingsCompleteGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderAreAllSiblingsCompleteGet$Json(params?: {
    workOrderId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderAreAllSiblingsCompleteGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderAddOrUpdateStageMoveDatePost
   */
  static readonly ApiWorkOrderAddOrUpdateStageMoveDatePostPath = '/api/WorkOrder/add-or-update-stage-move-date';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddOrUpdateStageMoveDatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddOrUpdateStageMoveDatePost$Plain$Response(params?: {
    body?: WorkOrderStageInfoDto
  }): Observable<StrictHttpResponse<WorkOrderStageInfoDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddOrUpdateStageMoveDatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderStageInfoDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddOrUpdateStageMoveDatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddOrUpdateStageMoveDatePost$Plain(params?: {
    body?: WorkOrderStageInfoDto
  }): Observable<WorkOrderStageInfoDtoBaseResponse> {

    return this.apiWorkOrderAddOrUpdateStageMoveDatePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderStageInfoDtoBaseResponse>) => r.body as WorkOrderStageInfoDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddOrUpdateStageMoveDatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddOrUpdateStageMoveDatePost$Json$Response(params?: {
    body?: WorkOrderStageInfoDto
  }): Observable<StrictHttpResponse<WorkOrderStageInfoDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddOrUpdateStageMoveDatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderStageInfoDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddOrUpdateStageMoveDatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddOrUpdateStageMoveDatePost$Json(params?: {
    body?: WorkOrderStageInfoDto
  }): Observable<WorkOrderStageInfoDtoBaseResponse> {

    return this.apiWorkOrderAddOrUpdateStageMoveDatePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderStageInfoDtoBaseResponse>) => r.body as WorkOrderStageInfoDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderToggleArchiveWorkOrderPost
   */
  static readonly ApiWorkOrderToggleArchiveWorkOrderPostPath = '/api/WorkOrder/toggle-archive-work-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderToggleArchiveWorkOrderPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveWorkOrderPost$Plain$Response(params?: {
    workOrderId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderToggleArchiveWorkOrderPostPath, 'post');
    if (params) {
      rb.query('workOrderId', params.workOrderId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderToggleArchiveWorkOrderPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveWorkOrderPost$Plain(params?: {
    workOrderId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderToggleArchiveWorkOrderPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderToggleArchiveWorkOrderPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveWorkOrderPost$Json$Response(params?: {
    workOrderId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderToggleArchiveWorkOrderPostPath, 'post');
    if (params) {
      rb.query('workOrderId', params.workOrderId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderToggleArchiveWorkOrderPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveWorkOrderPost$Json(params?: {
    workOrderId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderToggleArchiveWorkOrderPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderGetWoRefPost
   */
  static readonly ApiWorkOrderGetWoRefPostPath = '/api/WorkOrder/get-wo-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetWoRefPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderGetWoRefPost$Plain$Response(params?: {
    body?: WorkOrderListDto
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetWoRefPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetWoRefPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderGetWoRefPost$Plain(params?: {
    body?: WorkOrderListDto
  }): Observable<StringBaseResponse> {

    return this.apiWorkOrderGetWoRefPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetWoRefPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderGetWoRefPost$Json$Response(params?: {
    body?: WorkOrderListDto
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetWoRefPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetWoRefPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderGetWoRefPost$Json(params?: {
    body?: WorkOrderListDto
  }): Observable<StringBaseResponse> {

    return this.apiWorkOrderGetWoRefPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderGetNextWoRefGet
   */
  static readonly ApiWorkOrderGetNextWoRefGetPath = '/api/WorkOrder/get-next-wo-ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetNextWoRefGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetNextWoRefGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetNextWoRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetNextWoRefGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetNextWoRefGet$Plain(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiWorkOrderGetNextWoRefGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetNextWoRefGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetNextWoRefGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<StringBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetNextWoRefGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StringBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetNextWoRefGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetNextWoRefGet$Json(params?: {
  }): Observable<StringBaseResponse> {

    return this.apiWorkOrderGetNextWoRefGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<StringBaseResponse>) => r.body as StringBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderGetResourcesGet
   */
  static readonly ApiWorkOrderGetResourcesGetPath = '/api/WorkOrder/get-resources';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetResourcesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetResourcesGet$Plain$Response(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<StrictHttpResponse<ProductionResourceDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetResourcesGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('isArchived', params.isArchived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductionResourceDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetResourcesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetResourcesGet$Plain(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<ProductionResourceDtoListBaseResponse> {

    return this.apiWorkOrderGetResourcesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductionResourceDtoListBaseResponse>) => r.body as ProductionResourceDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetResourcesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetResourcesGet$Json$Response(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<StrictHttpResponse<ProductionResourceDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetResourcesGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('isArchived', params.isArchived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductionResourceDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetResourcesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetResourcesGet$Json(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<ProductionResourceDtoListBaseResponse> {

    return this.apiWorkOrderGetResourcesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductionResourceDtoListBaseResponse>) => r.body as ProductionResourceDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderAddResourcePost
   */
  static readonly ApiWorkOrderAddResourcePostPath = '/api/WorkOrder/add-resource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddResourcePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddResourcePost$Plain$Response(params?: {
    body?: ProductionResourceDto
  }): Observable<StrictHttpResponse<ProductionResourceDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddResourcePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductionResourceDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddResourcePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddResourcePost$Plain(params?: {
    body?: ProductionResourceDto
  }): Observable<ProductionResourceDtoBaseResponse> {

    return this.apiWorkOrderAddResourcePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductionResourceDtoBaseResponse>) => r.body as ProductionResourceDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddResourcePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddResourcePost$Json$Response(params?: {
    body?: ProductionResourceDto
  }): Observable<StrictHttpResponse<ProductionResourceDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddResourcePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductionResourceDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddResourcePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddResourcePost$Json(params?: {
    body?: ProductionResourceDto
  }): Observable<ProductionResourceDtoBaseResponse> {

    return this.apiWorkOrderAddResourcePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductionResourceDtoBaseResponse>) => r.body as ProductionResourceDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderUpdateResourcePut
   */
  static readonly ApiWorkOrderUpdateResourcePutPath = '/api/WorkOrder/update-resource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateResourcePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateResourcePut$Plain$Response(params?: {
    body?: ProductionResourceDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateResourcePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateResourcePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateResourcePut$Plain(params?: {
    body?: ProductionResourceDto
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateResourcePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateResourcePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateResourcePut$Json$Response(params?: {
    body?: ProductionResourceDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateResourcePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateResourcePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateResourcePut$Json(params?: {
    body?: ProductionResourceDto
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateResourcePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderToggleArchiveResourceDelete
   */
  static readonly ApiWorkOrderToggleArchiveResourceDeletePath = '/api/WorkOrder/toggle-archive-resource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderToggleArchiveResourceDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveResourceDelete$Plain$Response(params?: {
    productionResourceId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderToggleArchiveResourceDeletePath, 'delete');
    if (params) {
      rb.query('productionResourceId', params.productionResourceId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderToggleArchiveResourceDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveResourceDelete$Plain(params?: {
    productionResourceId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderToggleArchiveResourceDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderToggleArchiveResourceDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveResourceDelete$Json$Response(params?: {
    productionResourceId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderToggleArchiveResourceDeletePath, 'delete');
    if (params) {
      rb.query('productionResourceId', params.productionResourceId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderToggleArchiveResourceDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderToggleArchiveResourceDelete$Json(params?: {
    productionResourceId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderToggleArchiveResourceDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderGetSwimlaneDefinitionsGet
   */
  static readonly ApiWorkOrderGetSwimlaneDefinitionsGetPath = '/api/WorkOrder/get-swimlane-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetSwimlaneDefinitionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetSwimlaneDefinitionsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetSwimlaneDefinitionsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetSwimlaneDefinitionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetSwimlaneDefinitionsGet$Plain(params?: {
  }): Observable<WorkOrderSwimlaneDefinitionDtoListBaseResponse> {

    return this.apiWorkOrderGetSwimlaneDefinitionsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoListBaseResponse>) => r.body as WorkOrderSwimlaneDefinitionDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderGetSwimlaneDefinitionsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetSwimlaneDefinitionsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderGetSwimlaneDefinitionsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderGetSwimlaneDefinitionsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderGetSwimlaneDefinitionsGet$Json(params?: {
  }): Observable<WorkOrderSwimlaneDefinitionDtoListBaseResponse> {

    return this.apiWorkOrderGetSwimlaneDefinitionsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoListBaseResponse>) => r.body as WorkOrderSwimlaneDefinitionDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderAddSwimlaneDefinitionPost
   */
  static readonly ApiWorkOrderAddSwimlaneDefinitionPostPath = '/api/WorkOrder/add-swimlane-definition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddSwimlaneDefinitionPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddSwimlaneDefinitionPost$Plain$Response(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddSwimlaneDefinitionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddSwimlaneDefinitionPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddSwimlaneDefinitionPost$Plain(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<WorkOrderSwimlaneDefinitionDtoBaseResponse> {

    return this.apiWorkOrderAddSwimlaneDefinitionPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoBaseResponse>) => r.body as WorkOrderSwimlaneDefinitionDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderAddSwimlaneDefinitionPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddSwimlaneDefinitionPost$Json$Response(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderAddSwimlaneDefinitionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderAddSwimlaneDefinitionPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderAddSwimlaneDefinitionPost$Json(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<WorkOrderSwimlaneDefinitionDtoBaseResponse> {

    return this.apiWorkOrderAddSwimlaneDefinitionPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<WorkOrderSwimlaneDefinitionDtoBaseResponse>) => r.body as WorkOrderSwimlaneDefinitionDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderUpdateSwimlaneDefinitionPut
   */
  static readonly ApiWorkOrderUpdateSwimlaneDefinitionPutPath = '/api/WorkOrder/update-swimlane-definition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateSwimlaneDefinitionPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateSwimlaneDefinitionPut$Plain$Response(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateSwimlaneDefinitionPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateSwimlaneDefinitionPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateSwimlaneDefinitionPut$Plain(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateSwimlaneDefinitionPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderUpdateSwimlaneDefinitionPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateSwimlaneDefinitionPut$Json$Response(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderUpdateSwimlaneDefinitionPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderUpdateSwimlaneDefinitionPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderUpdateSwimlaneDefinitionPut$Json(params?: {
    body?: WorkOrderSwimlaneDefinitionDto
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderUpdateSwimlaneDefinitionPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderDeleteSwimlaneDefinitionDelete
   */
  static readonly ApiWorkOrderDeleteSwimlaneDefinitionDeletePath = '/api/WorkOrder/delete-swimlane-definition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderDeleteSwimlaneDefinitionDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderDeleteSwimlaneDefinitionDelete$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderDeleteSwimlaneDefinitionDeletePath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderDeleteSwimlaneDefinitionDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderDeleteSwimlaneDefinitionDelete$Plain(params?: {
    id?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderDeleteSwimlaneDefinitionDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderDeleteSwimlaneDefinitionDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderDeleteSwimlaneDefinitionDelete$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderDeleteSwimlaneDefinitionDeletePath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderDeleteSwimlaneDefinitionDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiWorkOrderDeleteSwimlaneDefinitionDelete$Json(params?: {
    id?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderDeleteSwimlaneDefinitionDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiWorkOrderReorderSwimlaneDefinitionsPut
   */
  static readonly ApiWorkOrderReorderSwimlaneDefinitionsPutPath = '/api/WorkOrder/reorder-swimlane-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderReorderSwimlaneDefinitionsPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderReorderSwimlaneDefinitionsPut$Plain$Response(params?: {
    body?: Array<WorkOrderSwimlaneDefinitionDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderReorderSwimlaneDefinitionsPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderReorderSwimlaneDefinitionsPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderReorderSwimlaneDefinitionsPut$Plain(params?: {
    body?: Array<WorkOrderSwimlaneDefinitionDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderReorderSwimlaneDefinitionsPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWorkOrderReorderSwimlaneDefinitionsPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderReorderSwimlaneDefinitionsPut$Json$Response(params?: {
    body?: Array<WorkOrderSwimlaneDefinitionDto>
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, WorkOrderService.ApiWorkOrderReorderSwimlaneDefinitionsPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiWorkOrderReorderSwimlaneDefinitionsPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWorkOrderReorderSwimlaneDefinitionsPut$Json(params?: {
    body?: Array<WorkOrderSwimlaneDefinitionDto>
  }): Observable<BooleanBaseResponse> {

    return this.apiWorkOrderReorderSwimlaneDefinitionsPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
